import groupApi from '@/api/group';

const SET_GROUPS = 'SET_GROUPS';
const ADD_GROUP = 'ADD_GROUP';
const DELETE_GROUP = 'DELETE_GROUP';
const UPDATE_GROUP = 'UPDATE_GROUP';

const state = {
  groups: []
};

const getters = {
  getGroups: state => {
    return state.groups;
  },
  getRootGroup: state => {
    return state.groups.find((group) => group.parentId === null);
  }
};

const mutations = {
  [SET_GROUPS] (state, groups) {
    state.groups = groups;
  },
  [ADD_GROUP] (state, group) {
    state.groups.push(group);
  },
  [UPDATE_GROUP] (state, group) {
    const index = state.groups.map(e => e.id).indexOf(group);
    state.groups.splice(index, 1, group);
  },
  [DELETE_GROUP] (state, groupId) {
    const index = state.groups.map(e => e.id).indexOf(groupId);
    state.groups.splice(index, 1);
  }
};

const actions = {
  retrieveGroups ({ commit }, { context }) {
    groupApi.getGroups(context).then(groups => {
      commit(SET_GROUPS, groups);
    });
  },
  createGroup ({ commit }, { context, group }) {
    return new Promise((resolve, reject) => {
      groupApi.createGroup(context, group).then(group => {
        commit(ADD_GROUP, group);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  updateGroup ({ commit }, { context, group }) {
    return new Promise((resolve, reject) => {
      groupApi.updateGroup(context, group).then(group => {
        commit(UPDATE_GROUP, group);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  deleteGroup ({ commit }, { context, id }) {
    return new Promise((resolve, reject) => {
      groupApi.deleteGroup(context, id).then(() => {
        commit(DELETE_GROUP, id);
        resolve();
      }, error => {
        reject(error);
      });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/group/index.js